import React from 'react';
import PropTypes from 'prop-types';
import {Route, Switch} from 'react-router-dom';
import withAdminLayout from './with-admin-layout';
import AdminEditCollectionPage from '../pages/admin/edit-collection';
import AdminCollectionListPage from '../pages/admin/collection-list';
import AdminCreateCollectionPage from '../pages/admin/create-collection';
import AdminEditFilePage from '../pages/admin/edit-file';
import AdminCreateFilePage from '../pages/admin/create-file';
import AdminFileListPage from '../pages/admin/file-list';
import AdminAnalyticsPage from '../pages/admin/analytics';
import AdminUsersPage from '../pages/admin/users';

const AdminRoutes = ({user: {privileged}}) => (
	<Switch>
		<Route exact path="/admin" component={AdminCollectionListPage}/>
		<Route exact path="/admin/collections/create" component={AdminCreateCollectionPage}/>
		<Route exact path="/admin/collections/:id" component={AdminEditCollectionPage}/>
		<Route exact path="/admin/collections/:parentId/files" component={AdminFileListPage}/>
		<Route exact path="/admin/collections/:parentId/files/create" component={AdminCreateFilePage}/>
		<Route exact path="/admin/collections/:parentId/files/:id" component={AdminEditFilePage}/>
		<Route exact path="/admin/analytics" component={AdminAnalyticsPage}/>
		{privileged && (
			<Route exact path="/admin/users" component={AdminUsersPage}/>
		)}
	</Switch>
);

AdminRoutes.propTypes = {
	user: PropTypes.object.isRequired
};

export default withAdminLayout(AdminRoutes);



// WEBPACK FOOTER //
// ./src/client/routes/admin.jsx